export default "__VITE_ASSET__a979c64f__"